export {
  InputField,
  type InputFieldProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/InputField';
